module.exports = __webpack_public_path__ + "static/media/Learn-Japanese-in-Delhi.c9d53a7b.jpg";